import { MODAL_IDS, useModal } from 'src/components'

import { OrderFilterProps } from '../types'

export const useOrderFilter = (props: OrderFilterProps) => {
  const {
    departureDateFrom,
    departureDateTo,
    handleSetDepartureDateFrom,
    handleSetDepartureDateTo,

    departure,
    destination,
    handleSetDeparture,
    handleSetDestination,
    handleSwapPoints,

    status,
    paymentStatus,
    handleSetStatus,
    handleSetPaymentStatus,

    search,
    handleSetSearch,

    mode,
    handleSetMode,

    id,

    isLaptop,
    isTablet,
    isLargeLaptop,

    orderLength,
    isLoading,
    allFilterLength,

    handleResetFilter
  } = props

  const { openModal, closeModal } = useModal()

  const handleOpenFilter = () => {
    openModal(MODAL_IDS.OrderFilterTable)
  }

  const handleCloseFilter = () => {
    closeModal(MODAL_IDS.OrderFilterTable)
  }

  const hasActiveFilters = Boolean(
    departureDateFrom || departureDateTo || departure || destination || status?.length || paymentStatus?.length
  )

  const statusDisplayText = status?.length ? ` Выбрано ${status?.length}` : ''
  const paymentStatusDisplayText = paymentStatus?.length ? ` Выбрано ${paymentStatus?.length}` : ''

  const orderCountText = `${orderLength} заявок`

  return {
    hasActiveFilters,
    statusDisplayText,
    paymentStatusDisplayText,
    orderCountText,
    isSearchMode: mode === 'search',
    isFilterMode: mode === 'filter',
    hasActiveFiltersBadge: Boolean(allFilterLength),

    isLaptop,
    isTablet,
    isLargeLaptop,
    isLoading,
    allFilterLength,
    departureDateFrom,
    departureDateTo,
    status,
    paymentStatus,
    search: search || '',
    departure: departure || '',
    destination: destination || '',
    id,

    handleOpenFilter,
    handleSetMode,
    handleSetSearch,
    handleResetFilter,
    handleSwapPoints,
    handleSetDeparture,
    handleSetDestination,
    handleSetDepartureDateFrom,
    handleSetDepartureDateTo,
    handleSetStatus,
    handleSetPaymentStatus,
    handleCloseFilter
  }
}
